module.exports = __webpack_public_path__ + "img/edit.a9faff9c.svg";